import { Component, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule,JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { MtrwlService,  } from '../_service_mtr';
import { Mtrwl } from '../_entity_mtr';


@Component({
  selector: 'app-mtrwl-edit',
  templateUrl: './mtrwl-edit.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, AdvComModule,MaterialModule],
})

export class MtrwlEditComponent extends JkDialogEditComponent<MtrwlService,Mtrwl>{
  getImagePath(item: Mtrwl): string {
      return item.WL001 + '-' + item.WL002 || 'unknown';
  }

  override srv!: MtrwlService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<MtrwlEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject,dialogRef,data);
  }
  markdown(): string {
    return this.item.WL013 || '';
  }
  editMarkdown(value: string): void {
    this.item.WL013 = value;
  }


}
